<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col-sm-3"></div>
      <div class="col-sm-6">
        <h2 class="text-center font-weight-bold">Buat Password</h2>
        <form @submit="requestChangePassword">
          <div class="form-group">
            <label for="InputPassword1" class="font-weight-bold">Password</label>
            <input
              v-model="password"
              type="password"
              class="form-control"
              id="InputPassword1"
              placeholder="Password"
            />
          </div>
          <div class="form-group">
            <label for="KonfirmasiInputPassword1" class="font-weight-bold">Konfirm Password</label>
            <input
              v-model="repassword"
              type="password"
              class="form-control"
              id="KonfirmasiInputPassword1"
              placeholder="Konfirm Password"
            />
          </div>
          <div class="text-center">
            <button
              type="submit"
              class="btn btn-success font-weight-bold"
              style="border-radius: 15px;
                width: 40%;"
            >LANJUT</button>
          </div>
        </form>
      </div>
      <div class="col-sm-3"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChangePassword",
  created() {
    this.token = this.$route.params.token;
  },
  data() {
    return {
      token: "",
      password: "",
      repassword: ""
    };
  },
  methods: {
    requestChangePassword(e) {
      e.preventDefault();
      if (this.password !== this.repassword) {
        return this.$swal({
          text: "Invalid, password and re-password is miss match"
        });
      }
      this.$axios
        .post("/api/v1/priority/user/reset-password", {
          token: this.token,
          password: this.password
        })
        .then(res => {
          this.$swal({ text: "Success reset password" });
          this.$router.push("/login");
        })
        .catch(err => {
          this.$swal({ text: "Failed reset password" });
        });
    }
  }
};
</script>

<style>
</style>